import React, { useState } from "react";
import { api } from "@/lib/api";

const inputCls = "w-full border border-stone-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-400";

export const Field = ({ label, id, type = "text", value, onChange, auto }) => (
  <label className="block" htmlFor={id}>
    <span className="block text-sm text-stone-600 mb-1">{label}</span>
    <input id={id} data-testid={id} type={type} value={value} autoComplete={auto}
      onChange={(e) => onChange(e.target.value)} className={inputCls} />
  </label>
);

const errText = (ex) => {
  const d = ex?.response?.data?.detail;
  return typeof d === "string" ? d : "Request failed. Check the fields and try again.";
};

// Generic small form: posts `body()` to `url`, then calls onDone(data).
export const AccountForm = ({ testid, title, hint, url, fields, submitLabel, onDone, danger = false }) => {
  const [vals, setVals] = useState(Object.fromEntries(fields.map((f) => [f.key, ""])));
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const { data } = await api.post(url, vals);
      setVals(Object.fromEntries(fields.map((f) => [f.key, ""])));
      onDone(data);
    } catch (ex) { setErr(errText(ex)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} data-testid={testid} className="bg-white border border-stone-200 rounded-2xl p-6 space-y-4">
      <div>
        <div className="font-display text-xl text-stone-900">{title}</div>
        {hint && <p className="text-sm text-stone-500 mt-1">{hint}</p>}
      </div>
      {fields.map((f) => (
        <Field key={f.key} id={`${testid}-${f.key.replace(/_/g, "-")}`} label={f.label} type={f.type || "password"}
          auto={f.auto} value={vals[f.key]} onChange={(v) => setVals((s) => ({ ...s, [f.key]: v }))} />
      ))}
      {err && <div className="text-sm text-rose-700" data-testid={`${testid}-error`}>{err}</div>}
      <button type="submit" disabled={busy || fields.some((f) => !vals[f.key])} data-testid={`${testid}-submit`}
        className={`px-5 py-2.5 rounded-lg text-white transition-colors disabled:opacity-50 ${danger ? "bg-rose-700 hover:bg-rose-600" : "bg-stone-900 hover:bg-stone-700"}`}>
        {busy ? "Working…" : submitLabel}
      </button>
    </form>
  );
};
